import axios from 'axios';

export const rejectUpdateRequest = async ({ updateID, reason, description, notifyUser }) => {
  const response = await axios.post('/admin/site/update/reject', {
    updateID,
    reason,
    description,
    notifyUser,
  });
  return response.data;
};
